// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleAutoUpdate_root__rXawI","activeContainer":"ToggleAutoUpdate_activeContainer__G-6Xf","text":"ToggleAutoUpdate_text__pOjq-","active":"ToggleAutoUpdate_active__d-pEK"};